import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import SlimSelect from 'slim-select';
import { Option } from 'slim-select/dist/store';

export interface SelectItemInterface {
  value: string | number;
  label: string;
  order?: number;
  group?: string;
}

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements OnInit, ControlValueAccessor {
  @ViewChild('selectElement', { static: true }) selectElement: ElementRef;
  @ViewChild('contentElement', { static: true }) contentElement: ElementRef;
  @Input() placeholder: string;
  @Input() multiple: boolean = false;
  @Input() options: SelectItemInterface[];
  @Input() required: boolean = false;
  @Input() isInvalid: boolean = false;
  @Input() sortBy: 'label' | 'order' | 'group' = 'label';
  @Input() sortOrder: 'asc' | 'desc' = 'asc';
  @Input() groupBy: string = null;
  private disabled = false;
  private onChange: (value: any) => void;
  private onTouch: () => void;
  private select: SlimSelect;
  open: boolean = false;

  constructor() {}

  ngOnInit() {
    if (this.multiple) {
      this.selectElement.nativeElement.setAttribute('multiple', 'multiple');
    }

    this.select = new SlimSelect({
      select: this.selectElement.nativeElement,
      data: this.options.map((option) => ({
        value: option.value.toString(),
        text: option.label,
      })),
      settings: {
        searchPlaceholder: 'Rechercher',
        searchText: 'Aucun résultat trouvé',
        searchingText: 'Recherche en cours...',
        closeOnSelect: true,
        placeholderText: this.placeholder || 'Sélectionnez',
        // minSelected: this.multiple ? 1 : 0,
        // maxValuesShown: 5,
        maxValuesMessage: '{number} éléments sélectionnés',
        contentLocation: this.contentElement.nativeElement,
        contentPosition: 'relative',
        allowDeselect: true,

        // showSearch: this.options.length > 10,

        // hideSelected: true,
        // allowEmptyOption: !this.required,
        // maxOptions: 30,
        // valueField: 'value',
        // labelField: 'label',
        // searchField: ['label'],
        // sortField: this.sortBy,
        // optgroupField: this.groupBy,
        // options: this.options as any[],
        // minSelected: this.multiple ? 1 : 0,
        // maxItems: this.multiple ? 1000 : 1,
      },
      events: {
        // mode: this.multiple ? 'multi' : 'single',
        beforeOpen: () => {
          this.open = true;
          this.onTouch?.();
        },
        afterClose: () => {
          this.open = false;
        },
        afterChange: (val: Option[]) => {
          // Make sure the value is an array if multiple is true
          // Make sure the value is a single value if multiple is false
          let formValue = val.map((option) => option.value);
          this.onChange?.(this.multiple ? formValue : formValue[0]);
        },
      },
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this.select.setSelected(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.select.settings.disabled = isDisabled;
  }
}
